import { JSX } from "react";

export const FormatUsersUnderline1 = ({
  className,
  ...props
}: JSX.IntrinsicElements["svg"]) => {
  return (
    <svg
      viewBox="0 0 166 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M6 8C54.0037 2.50566 105.634 10.5462 160 6.25789"
        stroke="#CFB2FF"
        strokeWidth="12"
        strokeLinecap="round"
      />
    </svg>
  );
};